import React, { useEffect, useState, useRef } from "react";
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	CardImg,
} from "reactstrap";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import {
	AvForm,
	AvField,
	AvRadioGroup,
	AvRadio,
} from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import LeadService from "services/Admin/LeadService";
import CompoundService from "services/Admin/CompoundService";
import BaseService from "services/BaseService";
import SelectOptions from "components/SelectOptions";
import { adminPrefix } from "configs/routePrefix";
import { useDispatch, useSelector } from "react-redux";
import { appendData, resetData } from "store/Mode/actions";
import "../style.scss";
import BuildingService from "services/Admin/BuildingService";
import PropertyService from "services/Admin/PropertyService";
import axios from "axios";

function UploadUnitImagesModal({ modal, toggle, ids, activeCanvasData }) {
	const dispatch = useDispatch();
	const modeData = useSelector((state) => state.Mode);
	const [percent, setPercent] = useState(0);
	const [images, setImages] = useState([]);
	const [unitsUpdated, setUnitsUpdated] = useState([]);
	const propertyService = new PropertyService();

	useEffect(() => {
		let building = modeData?.images?.find(
			(res) => res.id == activeCanvasData?.id
		);
		let update = building?.shapes
			.filter((res) => res.highlight)
			?.map((shape) => {
				return {
					id: shape.idImage?.id,
					path: shape.idImage?.path,
					shapes: [],
					constrains: shape?.hotspot,
					title: shape?.hotspot?.name,
					comesForm: {
						id: building?.id,
						path: building.path,
					},
				};
			});
		setUnitsUpdated(update);
		const allExist = update.every((obj2) =>
			modeData?.images.some((obj1) => obj1.id === obj2.id)
		);

		if (!allExist) {
			const notPresent = update.filter(
				(obj2) => !modeData?.images.some((obj1) => obj1.id === obj2.id)
			);
			dispatch(
				appendData({
					...modeData,
					images: [...modeData.images, ...notPresent],
				})
			);
		}
	}, []);

	const handleSubmit = () => {
		if (images.length == 0) {
			toast.error("Upload Images");
			return;
		}
		if (unitsUpdated.length == 0) {
			toast.error("Select Unit");
			return;
		}
		// let info = {
		// 	images_ids: images?.map((res) => res?.id),
		// };
		// if (unitsUpdated?.length > 1)
		// 	info["unit_ids"] = unitsUpdated?.map((res) => res?.constrains?.id);
		// if (unitsUpdated?.length === 1)
		// 	info["unit_id"] = unitsUpdated?.map((res) => res?.constrains?.id)[0];
		Promise.all(
			images?.map((res) =>
				propertyService.changeImage({
					images_ids: res?.unitImages?.map((res) => res?.id),
					unit_id: res?.id,
				})
			)
		).then((res) => {
			images?.map((unintImgs, index) => {
				if (res[index]?.status === 200) {
					const updatedData = modeData.images.map((img) => {
						let isExist = unitsUpdated.filter((unit) => unit.id == img.id);
						if (!!isExist?.length && isExist[0].id == img.id) {
							if (!!img?.images && !!img.images.length) {
								return {
									...img,
									images: [...img.images, ...images[index]?.unitImages],
								};
							} else {
								return {
									...img,
									images: [...images[index]?.unitImages],
								};
							}
						} else {
							return img;
						}
					});
					dispatch(appendData({ ...modeData, images: [...updatedData] }));
				}
			});
			toggle();
		});
		return;

		images?.map((res) => {
			propertyService.changeImage(info).then((response) => {
				if (response?.status) {
					const updatedData = modeData.images.map((img) => {
						let isExist = unitsUpdated.filter((unit) => unit.id == img.id);
						if (!!isExist?.length && isExist[0].id == img.id) {
							if (!!img?.images && !!img.images.length) {
								return {
									...img,
									// images: [...images]
									images: [...img.images, ...images],
								};
							} else {
								return {
									...img,
									images: [...images],
								};
							}
						} else {
							return img;
						}
					});
					dispatch(appendData({ ...modeData, images: [...updatedData] }));
					toggle();
				}
			});
		});

		propertyService.changeImage(info).then((response) => {
			if (response?.status) {
				const updatedData = modeData.images.map((img) => {
					let isExist = unitsUpdated.filter((unit) => unit.id == img.id);
					if (!!isExist?.length && isExist[0].id == img.id) {
						if (!!img?.images && !!img.images.length) {
							return {
								...img,
								// images: [...images]
								images: [...img.images, ...images],
							};
						} else {
							return {
								...img,
								images: [...images],
							};
						}
					} else {
						return img;
					}
				});
				dispatch(appendData({ ...modeData, images: [...updatedData] }));
				toggle();
			}
		});
	};

	const addImagesHandler = (e) => {
		let files = e.target.files;
		const filesData = Object.values(files);

		if (filesData.length) {
			const options = {
				onUploadProgress: (progressEvent) => {
					const { loaded, total } = progressEvent;
					let percentValue = (loaded * 100) / total;
					setPercent((p) => (percentValue > p ? percentValue : p));
				},
			};
			Promise.all(
				ids?.map((res) => {
					let imgs = [];
					Promise.all(
						filesData.map(async (file) => {
							let res = await new BaseService().postUpload(file, options);
							const createdFiles = { ...res.data.data, shapes: [] };
							imgs.push(createdFiles);
						})
					)?.then(() => {
						setPercent(0);
						setImages((prev) => [
							...prev,
							{
								...res,
								unitImages: imgs,
							},
						]);
					});
				})
			).catch(() => setPercent(0));
		}
	};

	return (
		<AvForm className="form-horizontal">
			<Modal
				isOpen={modal}
				toggle={toggle}
				className="scrollbar-container mt-5">
				<ModalHeader toggle={toggle}>
					Add New Images
					<br />
				</ModalHeader>
				<ModalBody>
					{percent > 0 && (
						<div className="mx-1">
							<div className="progress my-2">
								<div
									className="progress-bar progress-bar-striped"
									role="progressbar"
									style={{ width: percent + "%" }}
									aria-valuenow={`${percent}`}
									aria-valuemin="0"
									aria-valuemax="100"></div>
							</div>
						</div>
					)}

					<Row>
						<Col className="d-flex flex-wrap">
							{images.length === 0 ? (
								<Col md={12} className="parent-div my-4">
									<div
										className="p-2 bg-light "
										style={{ borderRadius: "10px" }}>
										<button
											type="button"
											className="px-4 w-100 btn-upload  font-size-16 "
											style={{
												border: "2px dashed rgb(202, 223, 247)",
												borderRadius: "10px",
												height: "150px",
												background: "#F3F3F9",
											}}>
											<div>
												<i className="fas fa-cloud-upload-alt text-success"></i>
											</div>
											<div>Click to upload or drag and drop</div>
											<p
												className="text-primary fw-bold btn-hover"
												style={{ textDecoration: "underline" }}>
												from computer
											</p>
										</button>
										<input
											type="file"
											multiple
											name="upfile"
											accept="image/*"
											onChange={addImagesHandler}
										/>
									</div>
								</Col>
							) : (
								<Row
									className="my-2 mx-1 py-2 "
									style={{ background: "#f3f3f9", borderRadius: "10px" }}>
									<Col
										md={12}
										className="parent-div mt-1 d-flex flex-lg-row-reverse  ">
										<Row className="align-items-center">
											<Col md={12} className="mb-3">
												<button
													type="button"
													className="btn btn-success px-4 btn-hover btn-upload ">
													Upload{" "}
												</button>
												<input
													type="file"
													name="upfile"
													accept="image/*"
													multiple
													onChange={addImagesHandler}
												/>
											</Col>
											{images[0]?.unitImages.map((img, index) => {
												return (
													<Col
														key={index}
														md={`${images[0].length == 1 ? 12 : 6}`}>
														<CardImg
															className="position-relative m-1"
															src={img?.path}
															alt={img?.path}></CardImg>
													</Col>
												);
											})}
										</Row>
									</Col>
								</Row>
							)}
						</Col>
					</Row>
				</ModalBody>

				<ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-end">
					<button type="button" onClick={toggle} className="btn btn-secondary">
						Cancel
					</button>
					<button
						type="submit"
						onClick={() => handleSubmit()}
						className="btn btn-success">
						Submit
					</button>
				</ModalFooter>
			</Modal>
		</AvForm>
	);
}

export default UploadUnitImagesModal;
